import {
  Brain,
  Sparkles,
  Home,
  HandHeart,
  Stethoscope,
  Building2,
  Flower2,
  Trees,
  Microscope,
} from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const audiences = [
  { icon: Brain, label: "Individuals living with Dementia" },
  { icon: Sparkles, label: "Individuals living with Alzheimer's Disease" },
  { icon: Home, label: "Families" },
  { icon: HandHeart, label: "Caregivers" },
  { icon: Stethoscope, label: "Clinicians" },
  { icon: Building2, label: "Hospitals" },
  { icon: Flower2, label: "Memory Care Centers" },
  { icon: Trees, label: "Senior Living Communities" },
  { icon: Microscope, label: "Researchers" },
];

export default function Audiences() {
  return (
    <section className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="audiences-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow number="07" label="Who We Build For" />
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#111827] max-w-2xl">
            Built for everyone in the{" "}
            <span className="font-serif-italic text-[#7F9F43]">circle of care.</span>
          </h2>
        </Reveal>

        <div className="mt-14 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {audiences.map((a, i) => (
            <Reveal key={a.label} delay={(i % 3) * 0.07}>
              <div
                className="group flex items-center gap-4 rounded-2xl bg-white border border-gray-100 px-6 py-5 card-soft hover:border-[#7F9F43]/40 hover:-translate-y-0.5 transition-[border-color,transform] duration-400"
                data-testid={`audience-card-${i}`}
              >
                <span className="h-10 w-10 shrink-0 rounded-xl bg-[#E89A4D]/10 flex items-center justify-center text-[#E89A4D] group-hover:bg-[#E89A4D] group-hover:text-white transition-colors duration-400">
                  <a.icon size={19} strokeWidth={1.75} />
                </span>
                <span className="text-sm md:text-base font-medium text-[#111827]">{a.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
